import Pro1 from '../assets/Caregiver.png';
import Pro2 from '../assets/capstone1Desk.png';
import Pro3 from '../assets/VAmovieDesk.png';
import Pro4 from '../assets/rocketDesk.png';
import Pro5 from '../assets/bookStore.png';
import Pro6 from '../assets/airQuality-des.png';
import Pro7 from '../assets/math.png';
import Pro8 from '../assets/cat.avif';
import Pro9 from '../assets/Budget.png';
import Pro10 from '../assets/apointment.png';
import Pro11 from '../assets/college.png';
import Pro12 from '../assets/social-work-services.png';

const projectCardData = [
  {
    imgsrc: Pro12,
    title: 'Social Service Worker',
    text: "Kindness can transform someone's dark moment with a blaze of light. You'll never know how much your caring matters.' - Amy Leigh Mercree. There are only four kinds of people in the world: Those who have been caregivers. Those who are currently caregivers. Those who will be caregivers, and those who will need a caregiver.",
    view: '',
    source: '',
  },
  {
    imgsrc: Pro1,
    title: 'Personal Support Worker',
    text: "Kindness can transform someone's dark moment with a blaze of light. You'll never know how much your caring matters.' - Amy Leigh Mercree. There are only four kinds of people in the world: Those who have been caregivers. Those who are currently caregivers. Those who will be caregivers, and those who will need a caregiver.",
    view: 'https://nacctry.netlify.app/',
    source: 'https://github.com/Amazinggracee/Personal-Support-Worker',
  },
  {
    imgsrc: Pro2,
    title: 'Event',
    text: "The Capstone project is centered around the creation of a conference or event website with the theme of 'Reduce, Reuse and Recycle.' This website is designed to serve as a platform for promoting and hosting an event that focuses on sustainability and environmental consciousness. Its core mission is to advocate and raise awareness about the principles of reducing waste, reusing resources, and recycling materials, all with the aim of contributing to a greener and more sustainable future.",
    view: 'https://amazinggracee.github.io/capstone-project/',
    source: 'https://github.com/Amazinggracee/capstone-project',
  },
  {
    imgsrc: Pro3,
    title: 'Movie Website',
    text: 'This entails the creation of a custom web application that relies on data and functionality provided by an external API. You will develop a unique online platform that harnesses the capabilities of an external application programming interface (API) to enhance its features and provide users with an enriched experience. Your web application will be designed to access, process, and display data from this external source, allowing you to leverage the resources and services offered by the API to create a dynamic and personalized online environment.',
    view: 'https://amazinggracee.github.io/VA-Movies-capstone2/dist',
    source: 'https://github.com/Amazinggracee/VA-Movies-capstone2',
  },
  {
    imgsrc: Pro4,
    title: 'Rocket Booking',
    text: "A web application is in development for a company specializing in both commercial space travel services. Users can reserve seats on rockets and participate in meticulously curated space missions of their choice. This exciting endeavor marks a significant step forward in making space exploration accessible to a wider audience, bridging the gap between the dream of space travel and its real-world fulfillment. The application will not only enable bookings for rocket journeys but also facilitate engagement in carefully chosen space expeditions, making it a one-stop destination for those who aspire to venture beyond our planet's boundaries.",
    view: 'https://rocket-mission-iu7s.onrender.com/',
    source: 'https://github.com/Amazinggracee/rocket-mission',
  },
  {
    imgsrc: Pro5,
    title: 'BookStore',
    text: 'This is a simple book store app built with React.js. It uses the Google Books API to search for books and display them. It also uses React Router to navigate between pages.',
    view: 'https://bookstore-seven-gamma.vercel.app/',
    source: 'https://github.com/Amazinggracee/Bookstore',
  },
  {
    imgsrc: Pro6,
    title: 'Air Quality',
    text: 'This React capstone project is about building a mobile web application to check a list of metrics (numeric values) that you will create using React and Redux.',
    view: 'https://air-quality-lyqt.onrender.com/',
    source: 'https://github.com/Amazinggracee/Air-Quality',
  },
  {
    imgsrc: Pro7,
    title: 'Math-Magician',
    text: 'This is the first project of the Math Magicians application. You will set up the environment and tools needed to develop a React application. In the following projects, you will develop the actual application.',
    view: 'https://math-magician-58mh.onrender.com/',
    source: 'https://github.com/Amazinggracee/math-magicians',
  },
  {
    imgsrc: Pro8,
    title: 'Matruby-catalog-group-capstone',
    text: 'This Ruby-based group capstone project allows users to create and manage a catalog of their personal belongings. It provides a user-friendly interface for organizing and categorizing items, making it easy to keep track of your possessions.',
    view: '',
    source: 'https://github.com/Bestbynature/ruby-catalog-group-capstone',
  },
  {
    imgsrc: Pro9,
    title: 'The-budget-app',
    text: 'The Ruby on Rails capstone project is about building a mobile web application where you can manage your budget: you have a list of transactions associated with a category, so that you can see how much money you spent and on what.',
    view: 'https://the-budget.onrender.com',
    source: 'https://github.com/Amazinggracee/The-budget-app',
  },
  {
    imgsrc: Pro10,
    title: 'Doctor Appointment App',
    text: 'The App is a web-based application designed to simplify the process of scheduling and managing appointments with healthcare providers. This open-source project aims to provide a user-friendly interface for patients to book appointments, view their medical history, and receive reminders for upcoming visits. Additionally, it offers healthcare professionals a platform to manage their schedules and access patient information efficiently.',
    view: 'https://doctor-app-u5x6.onrender.com/',
    source: 'https://github.com/Amazinggracee/appointment-app-front-end',
  },
  {
    imgsrc: Pro11,
    title: 'Fashion Design College',
    text: 'The college website is an online platform that serves as the primary source of information for our college community. It provides a wealth of information about our college, its academic programs, student life, resources, and services.',
    view: 'https://amazinggracee.github.io/College/',
    source: 'https://github.com/Amazinggracee/College',
  },
];

export default projectCardData;
